import { NoticeLoading } from '@fs/zion-icon'
import { Alert, Button, Card, Paragraph, Row, Separator } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

const MultipleImageArksWarning = ({ yesHandler = () => {}, noHandler = () => {}, loading = false }) => {
  const [t] = useTranslation()

  return (
    <Card margins="dense">
      <Alert type="warning" outlined>
        {t('index.multiple-images-warning.title', 'Extended load time')}
      </Alert>
      <Separator size="xs" />

      <Paragraph size="sm" dense>
        {t(
          'index.multiple-images-warning.description',
          "The person's information is linked to multiple pages. Loading may take a long time."
        )}
      </Paragraph>
      <Paragraph size="sm" dense>
        {t(
          'index.multiple-images-warning.confirmation',
          'Would you like to proceed? If you do, you will be able to edit their details.'
        )}
      </Paragraph>
      <Separator size="xs" />
      <Row alignX="end">
        <Button
          data-testid="multiple-images-warning-no"
          linkName="multiple-images-warning-no"
          emphasis="high"
          onClick={noHandler}
          disabled={loading}
        >
          {t('edit-index.person-details.primary-no', 'No')}
        </Button>
        <Button
          data-testid="multiple-images-warning-yes"
          linkName="multiple-images-warning-yes"
          emphasis="medium"
          onClick={yesHandler}
          Icon={loading ? NoticeLoading : undefined}
          iconAtEnd
          disabled={loading}
        >
          {t('edit-index.person-details.primary-yes', 'Yes')}
        </Button>
      </Row>
    </Card>
  )
}

export default MultipleImageArksWarning
